export enum FeedbackPlacement {
    SIDE_PANEL = "IHUB_FEEDBACK",
    DECK_DECORATION = "IHUB_FEEDBACK_DECK_DECORATION",
    SIDE_PANEL_WITH_METADATA = "IHUB_FEEDBACK_WITH_METADATA",
    DECK_DECORATION_WITH_METADATA = "IHUB_FEEDBACK_DECK_DECORATION_WITH_METADATA",
}
